var map = {
	"./shipo-icon-weather-cloudy.svg": "1157",
	"./shipo-icon-weather-foggy.svg": "6f3e",
	"./shipo-icon-weather-raining.svg": "eee4",
	"./shipo-icon-weather-stormy.svg": "d590",
	"./shipo-icon-weather-sunny.svg": "d194"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d23";